import { useEffect, useState } from "react";
import { useReducedMotion } from "framer-motion";

export { useReducedMotion };

export const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(() =>
        typeof window !== "undefined" ? window.matchMedia(query).matches : false
    );
    useEffect(() => {
        const mq = window.matchMedia(query);
        const onChange = () => setMatches(mq.matches);
        onChange();
        mq.addEventListener("change", onChange);
        return () => mq.removeEventListener("change", onChange);
    }, [query]);
    return matches;
};

export const useIsMobile = () => useMediaQuery("(max-width: 1023px)");
export const useFinePointer = () =>
    useMediaQuery("(hover: hover) and (pointer: fine)");
